module.exports = __webpack_public_path__ + "static/logojebouge-a95aa12be145205c61401f6af2100a97.png";